import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import FileSpec from "../pages/FileSpec";
import Dashboard from "../pages/Dashboard";
import TestSuite from "../pages/TestSuite";
import Task from "../pages/Task";
import ResultDetail from "../pages/results/ResultDetail";
import ProcessAutomationResultDetail from "../pages/results/ProcessAutomationResultDetail";
import TestCase from "../pages/TestCase";
import JobQueue from "../pages/JobQueue";
import JobDetail from "../pages/JobDetail";
import RuleBuilder from "../pages/features/RuleBuilder";
import MasterSuite from "../pages/mastersuite/MasterSuite";
import MasterSuiteNewPage from "../pages/mastersuite/MasterSuiteNewPage";
import MasterSuiteViewPage from "../pages/mastersuite/MasterSuiteViewPage";
import EnvironmentLibrary from "../pages/admin/environment/EnvironmentLibrary";
import MasterSuiteResults from "../pages/results/MasterSuiteResults";
import Results from "../pages/results/Results";
import Compare from "../pages/features/Compare";
import UIAutomation from "../pages/UIAutomation";
import UIAutomationBuilder from "../pages/UIAutomationBuilder";
import UIAutomationResults from "../pages/UIAutomationResults";
import UITestResultDetail from "../pages/results/UITestResultDetail";
import GatewayPage from "../pages/gateway/GatewayPage";
import Settings from "../pages/admin/settings/Settings";
import AdminHome from "../pages/admin/AdminHome";
import Agents from "../pages/admin/agents/Agents";
import Projects from "../pages/admin/projects/Projects";

function ContentRoute() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Unified compare page */}
        <Route path="/compare" element={<Compare />} />

        {/* Keep old routes redirecting to /compare for any bookmarks */}
        <Route path="/features/dbtofile" element={<Compare />} />
        <Route path="/features/dbtodb" element={<Compare />} />
        <Route path="/features/filetofile" element={<Compare />} />

        <Route path="/features/rulebuilder" element={<RuleBuilder />} />
        <Route path="/libraries/filespec" element={<FileSpec />} />
        <Route path="/libraries/suites" element={<TestSuite />} />
        <Route path="/libraries/task" element={<Task />} />
        <Route path="/results" element={<Results />} />
        <Route path="/results/details" element={<ResultDetail />} />
        <Route path="/results/process" element={<ProcessAutomationResultDetail />} />
        <Route path="/results/mastersuite" element={<MasterSuiteResults />} />
        <Route path="/suite/details" element={<TestCase />} />
        <Route path="/jobs" element={<JobQueue />} />
        <Route path="/jobs/details" element={<JobDetail />} />
        <Route path="/admin" element={<AdminHome />} />
        <Route path="/environments" element={<EnvironmentLibrary />} />
        <Route path="/admin/settings" element={<Settings />} />
        <Route path="/admin/agents" element={<Agents />} />
        <Route path="/admin/projects" element={<Projects />} />
        <Route path="/mastersuite" element={<MasterSuite />} />
        <Route path="/mastersuite/new" element={<MasterSuiteNewPage />} />
        <Route path="/mastersuite/view/:name" element={<MasterSuiteViewPage />} />
        <Route
          path="/mastersuite/scheduled"
          element={<MasterSuite initialTab="scheduled" />}
        />

        {/* ─── UI Automation ────────────────────────────────── */}
        <Route path="/ui-automation" element={<UIAutomation />} />
        <Route
          path="/ui-automation/builder"
          element={<UIAutomationBuilder />}
        />
        <Route path="/ui-automation/results" element={<UITestResultDetail />} />

        {/* ─── Gateway ──────────────────────────────────────── */}
        <Route path="/gateway" element={<GatewayPage />} />

        {/* Unmatched URL — a typo or a stale/bookmarked link — previously
            rendered a blank page. Send it to the Dashboard instead. */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </div>
  );
}

export default ContentRoute;
